import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    performed_tests: [],
    total: 0,
    centers: [],
    contentCsvToExport: 'data:text/csv;charset=utf-8,',
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_PERFORMED_TESTS:
            return {
                ...state,
                performed_tests: payload.performed_tests,
                total: payload.total,
                centers: payload.centers,
            };
        case actions.CHANGE_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS:
            return {
                ...state,
                contentCsvToExport: payload,
            };
        case actions.RESET_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS:
            return {
                ...state,
                contentCsvToExport: 'data:text/csv;charset=utf-8,',
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/tests-conducted/tests-conducted.reducer.js